'use strict';

var GridAddRowButtonDirective = function GridAddRowButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-add-row-button.html'),
    controller: 'GridAddRowButtonController'
  };
};
GridAddRowButtonDirective.$inject = [];
module.exports = GridAddRowButtonDirective;